/**
 * Get parameters from data attributes
 * @param {string} attr Parameter value to get
 */
function getSysAttr(attr) {
    return document.querySelector(`[${attr}]`)
        .attributes[attr].value || '';
}

/**
 * Get swiftype engine key value
 * @returns {*}
 */
export function getEngineKey() {
    return getSysAttr('data-engine-key');
}

/**
 * Get swiftype engine URL
 * @returns {*}
 */
export function getEngineUrl() {
    return getSysAttr('data-engine-url');
}



// WEBPACK FOOTER //
// ./src/js/helpers/sysAttrs.js